import React, { useEffect, useRef } from 'react';
import './PresenceMap.css';

// All showroom / dealer locations. Adding a new city later is just one
// more object in this array — nothing else needs to change.
//
// Two groups combined here:
//  1. India — detailed city-level dealer network (existing data)
//  2. Global — international presence, pulled from the old site's
//     Google Charts map (UAE, UK, USA, GCC, Australia, etc.)
const LOCATIONS = [
  // ── India — city-level dealer network ──
  { lat: 21.1702, lng: 72.8311, name: 'Surat' },
  { lat: 23.0225, lng: 72.5714, name: 'Ahmedabad' },
  { lat: 22.3039, lng: 70.8022, name: 'Rajkot' },
  { lat: 19.0760, lng: 72.8777, name: 'Mumbai' },
  { lat: 12.9716, lng: 77.5946, name: 'Bengaluru' },
  { lat: 21.0077, lng: 75.5626, name: 'Jalgaon' },
  { lat: 22.5726, lng: 88.3639, name: 'Kolkata' },
  { lat: 18.5204, lng: 73.8567, name: 'Pune' },
  { lat: 28.7041, lng: 77.1025, name: 'Delhi' },
  { lat: 22.4707, lng: 70.0577, name: 'Jamnagar' },
  { lat: 16.7050, lng: 74.2433, name: 'Kolhapur' },
  { lat: 34.083656, lng: 74.797371, name: 'Srinagar' },
  { lat: 11.2194, lng: 78.1677, name: 'Namakkal' },
  { lat: 19.2403, lng: 73.1305, name: 'Kalyan' },
  { lat: 27.17667, lng: 78.008072, name: 'Agra' },
  { lat: 9.151239, lng: 76.730766, name: 'Adoor' },
  { lat: 20.937424, lng: 77.779549, name: 'Amravati' },
  { lat: 19.101053, lng: 74.740677, name: 'Ahmednagar' },
  { lat: 26.449896, lng: 74.639915, name: 'Ajmer' },
  { lat: 20.707228, lng: 77.00296, name: 'Akola' },
  { lat: 27.560932, lng: 76.625015, name: 'Alwar' },
  { lat: 23.116444, lng: 83.196121, name: 'Ambikapur' },
  { lat: 31.63398, lng: 74.872261, name: 'Amritsar' },
  { lat: 22.555426, lng: 72.951439, name: 'Anand' },
  { lat: 14.685564, lng: 77.595406, name: 'Ananthapur' },
  { lat: 21.617355, lng: 72.997627, name: 'Ankleshwar' },
  { lat: 23.673944, lng: 86.952393, name: 'Asansol' },
  { lat: 19.901054, lng: 75.352478, name: 'Aurangabad' },
  { lat: 24.75, lng: 84.370003, name: 'Aurangabad (Bihar)' },
  { lat: 19.166784, lng: 73.236794, name: 'Badalpur' },
  { lat: 16.1725, lng: 75.6557, name: 'Bagalkot' },
  { lat: 21.138327, lng: 73.09539, name: 'Baradoli' },
  { lat: 28.375694, lng: 79.435959, name: 'Bareilly' },
  { lat: 30.210995, lng: 74.945473, name: 'Bathinda' },
  { lat: 26.100735, lng: 74.319077, name: 'Beawar' },
  { lat: 18.992012, lng: 75.776138, name: 'Beed' },
  { lat: 15.850367, lng: 74.504662, name: 'Belgaum' },
  { lat: 25.253391, lng: 86.989059, name: 'Bhagalpur' },
  { lat: 21.705723, lng: 72.998199, name: 'Bharuch' },
  { lat: 21.7645, lng: 72.1519, name: 'Bhavnagar' },
  { lat: 21.195434, lng: 81.967146, name: 'Bhilai' },
  { lat: 25.346251, lng: 74.636383, name: 'Bhilwara' },
  { lat: 16.544893, lng: 81.52124, name: 'Bhimavaram' },
  { lat: 28.2088, lng: 76.8446, name: 'Bhiwadi' },
  { lat: 23.259933, lng: 77.412613, name: 'Bhopal' },
  { lat: 20.296059, lng: 85.824539, name: 'Bhubaneshwar' },
  { lat: 23.242001, lng: 69.666931, name: 'Bhuj' },
  { lat: 21.0133461, lng: 75.77745, name: 'Bhusawal' },
  { lat: 25.9268, lng: 74.6506, name: 'Bijainagar' },
  { lat: 28.027138, lng: 73.302155, name: 'Bikaner' },
  { lat: 22.078642, lng: 82.152328, name: 'Bilaspur' },
  { lat: 20.769026, lng: 72.977776, name: 'Bilimora' },
  { lat: 24.696135, lng: 84.986954, name: 'Bodh Gaya' },
  { lat: 11.258753, lng: 75.780411, name: 'Calicut' },
  { lat: 20.4613641, lng: 74.9898334, name: 'Chalisgaon' },
  { lat: 30.741482, lng: 76.768066, name: 'Chandigarh' },
  { lat: 9.4519851, lng: 76.5367065, name: 'Changanacherry' },
  { lat: 13.067439, lng: 80.237617, name: 'Chennai' },
  { lat: 13.31232, lng: 75.770889, name: 'Chikmagalur' },
  { lat: 17.53231, lng: 73.517792, name: 'Chiplun' },
  { lat: 9.931233, lng: 76.267303, name: 'Cochin' },
  { lat: 11.0168, lng: 76.9558, name: 'Coimbatore' },
  { lat: 20.462521, lng: 85.882988, name: 'Cuttack' },
  { lat: 22.8379, lng: 74.2531, name: 'Dahod' },
  { lat: 26.152973, lng: 85.901413, name: 'Darbhanga' },
  { lat: 14.4647312, lng: 75.9233243, name: 'Davangere' },
  { lat: 24.258503, lng: 72.190674, name: 'Deesa' },
  { lat: 30.321915, lng: 78.026619, name: 'Dehradun' },
  { lat: 23.795399, lng: 86.427040, name: 'Dhanbad' },
  { lat: 20.903118, lng: 74.774986, name: 'Dhule' },
  { lat: 27.472834, lng: 94.911964, name: 'Dibrugarh' },
  { lat: 21.324507, lng: 74.556389, name: 'Dondaicha' },
  { lat: 24.20122, lng: 87.62048, name: 'Dumka' },
  { lat: 21.1870039, lng: 81.2825047, name: 'Durg' },
  { lat: 23.53344, lng: 87.32193, name: 'Durgapur' },
  { lat: 9.9920905, lng: 76.2864593, name: 'Ernakulam' },
  { lat: 11.342423, lng: 77.728165, name: 'Erode' },
  { lat: 15.42879, lng: 75.631269, name: 'Gadag' },
  { lat: 23.0791, lng: 70.140152, name: 'Gandhidham' },
  { lat: 23.233086, lng: 72.651634, name: 'Gandhinagar' },
  { lat: 28.667856, lng: 77.449791, name: 'Ghaziabad' },
  { lat: 15.496777, lng: 73.827827, name: 'Goa' },
  { lat: 22.7651559, lng: 73.6093769, name: 'Godhra' },
  { lat: 21.961946, lng: 70.792297, name: 'Gondal' },
  { lat: 26.765844, lng: 83.364944, name: 'Gorakhpur' },
  { lat: 16.314209, lng: 80.435028, name: 'Guntur' },
  { lat: 28.457523, lng: 77.026344, name: 'Gurgaon' },
  { lat: 10.595821, lng: 76.032944, name: 'Guruvayoor' },
  { lat: 26.148043, lng: 91.731377, name: 'Guwahati' },
  { lat: 26.218287, lng: 78.182831, name: 'Gwalior' },
  { lat: 29.2183, lng: 79.5130, name: 'Haldwani' },
  { lat: 29.625996, lng: 74.287491, name: 'Hanumangarh' },
  { lat: 29.94569, lng: 78.164246, name: 'Haridwar' },
  { lat: 23.5932506, lng: 72.971911, name: 'Himatnagar' },
  { lat: 29.151861, lng: 75.721123, name: 'Hisar' },
  { lat: 15.2689, lng: 76.3909, name: 'Hospet' },
  { lat: 15.371598, lng: 75.101166, name: 'Hubli' },
  { lat: 17.387140, lng: 78.491684, name: 'Hyderabad' },
  { lat: 16.709002, lng: 74.456078, name: 'Ichalkaranji' },
  { lat: 22.719568, lng: 75.857727, name: 'Indore' },
  { lat: 23.16877, lng: 79.931847, name: 'Jabalpur' },
  { lat: 19.07, lng: 82.029999, name: 'Jagdalpur' },
  { lat: 26.92207, lng: 75.778885, name: 'Jaipur' },
  { lat: 26.889175, lng: 70.867766, name: 'Jaisalmer' },
  { lat: 31.326015, lng: 75.57618, name: 'Jalandhar' },
  { lat: 19.830005, lng: 75.879995, name: 'Jalna' },
  { lat: 34.083656, lng: 74.797371, name: 'Jammu' },
  { lat: 22.8046, lng: 86.2029, name: 'Jamshedpur' },
  { lat: 25.436298, lng: 78.567352, name: 'Jhansi' },
  { lat: 26.263863, lng: 73.008957, name: 'Jodhpur' },
  { lat: 21.515471, lng: 70.456444, name: 'Junagadh' },
  { lat: 17.320486, lng: 76.839752, name: 'Kalaburagi' },
  { lat: 22.606001, lng: 73.462997, name: 'Kalol' },
  { lat: 11.874477, lng: 75.370369, name: 'Kannur' },
  { lat: 26.449923, lng: 80.331871, name: 'Kanpur' },
  { lat: 31.379999, lng: 75.379997, name: 'Kapurthala' },
  { lat: 17.287505, lng: 74.157496, name: 'Karad' },
  { lat: 18.438555, lng: 79.128838, name: 'Karimnagar' },
  { lat: 29.685629, lng: 76.990547, name: 'Karnal' },
  { lat: 23.833717, lng: 80.420609, name: 'Katni' },
  { lat: 20.711622, lng: 76.566132, name: 'Khamgaon' },
  { lat: 17.247253, lng: 80.151443, name: 'Khammam' },
  { lat: 22.34601, lng: 87.231972, name: 'Kharagpur' },
  { lat: 26.588528, lng: 74.872513, name: 'Kishangarh' },
  { lat: 8.8932, lng: 76.6141, name: 'Kollam' },
  { lat: 22.3516717, lng: 82.7458283, name: 'Korba' },
  { lat: 25.1695204, lng: 75.8539808, name: 'Kota' },
  { lat: 9.591441, lng: 76.522171, name: 'Kottayam' },
  { lat: 13.632182, lng: 74.690544, name: 'Kundapura' },
  { lat: 15.834536, lng: 78.029366, name: 'Kurnool' },
  { lat: 26.8467, lng: 80.9462, name: 'Lucknow' },
  { lat: 30.900965, lng: 75.857277, name: 'Ludhiana' },
  { lat: 16.737509, lng: 78.008125, name: 'Mahabubnagar' },
  { lat: 20.5549916, lng: 74.5344192, name: 'Malegaon' },
  { lat: 20.886482, lng: 76.21627, name: 'Malkapur' },
  { lat: 24.076836, lng: 75.069298, name: 'Mandsaur' },
  { lat: 12.9141507, lng: 74.8559478, name: 'Mangalore' },
  { lat: 15.286691, lng: 73.96978, name: 'Margao' },
  { lat: 27.492413, lng: 77.673676, name: 'Mathura' },
  { lat: 28.984644, lng: 77.705956, name: 'Meerut' },
  { lat: 23.586761, lng: 72.369949, name: 'Mehsana' },
  { lat: 23.470012, lng: 73.299988, name: 'Modasa' },
  { lat: 30.81646, lng: 75.171707, name: 'Moga' },
  { lat: 28.841064, lng: 78.795319, name: 'Moradabad' },
  { lat: 22.811989, lng: 70.823616, name: 'Morbi' },
  { lat: 29.471397, lng: 77.696732, name: 'Muzaffarnagar' },
  { lat: 26.121473, lng: 85.368752, name: 'Muzaffarpur' },
  { lat: 12.311827, lng: 76.652985, name: 'Mysore' },
  { lat: 22.700001, lng: 72.870003, name: 'Nadiad' },
  { lat: 26.3333393, lng: 92.6833273, name: 'Nagaon' },
  { lat: 8.17445, lng: 77.432159, name: 'Nagarcoil' },
  { lat: 21.146633, lng: 79.08886, name: 'Nagpur' },
  { lat: 19.169815, lng: 77.319717, name: 'Nanded' },
  { lat: 19.997454, lng: 73.789803, name: 'Nashik' },
  { lat: 24.9291, lng: 73.8213, name: 'Nathdwara' },
  { lat: 19.033, lng: 73.0297, name: 'Navi Mumbai' },
  { lat: 20.9227528, lng: 72.9088799, name: 'Navsari' },
  { lat: 24.465285, lng: 74.871128, name: 'Neemuch' },
  { lat: 14.442599, lng: 79.986458, name: 'Nellore' },
  { lat: 28.474388, lng: 77.50399, name: 'Noida' },
  { lat: 24.179331, lng: 72.426682, name: 'Palanpur' },
  { lat: 19.695768, lng: 72.763657, name: 'Palghar' },
  { lat: 25.771315, lng: 73.323685, name: 'Pali' },
  { lat: 30.695202, lng: 76.854172, name: 'Panchkulla' },
  { lat: 29.398928, lng: 76.977081, name: 'Panipat' },
  { lat: 19.25779, lng: 76.773743, name: 'Parbhani' },
  { lat: 9.264758, lng: 76.787041, name: 'Pathanamthitta' },
  { lat: 32.265942, lng: 75.646873, name: 'Pathankot' },
  { lat: 30.34, lng: 76.379997, name: 'Patiala' },
  { lat: 25.612677, lng: 85.158875, name: 'Patna' },
  { lat: 10.770388, lng: 76.37706, name: 'Pattambi' },
  { lat: 12.0328072, lng: 75.2684555, name: 'Payyanur' },
  { lat: 10.1319, lng: 76.4822, name: 'Perumbavoor' },
  { lat: 11.916064, lng: 79.812325, name: 'Pondicherry' },
  { lat: 21.640575, lng: 69.605965, name: 'Porbandar' },
  { lat: 11.2553885, lng: 75.7960016, name: 'Puthiyara' },
  { lat: 21.9, lng: 83.400002, name: 'Raigarh' },
  { lat: 21.2376284, lng: 81.5962147, name: 'Raipur' },
  { lat: 17.004393, lng: 81.783325, name: 'Rajahmundry' },
  { lat: 12.489392, lng: 78.567913, name: 'Rajapalayam' },
  { lat: 21.097855, lng: 81.033707, name: 'Rajnandgaon' },
  { lat: 23.344101, lng: 85.309563, name: 'Ranchi' },
  { lat: 23.334169, lng: 75.037636, name: 'Ratlam' },
  { lat: 17.2478, lng: 73.3709, name: 'Ratnagiri' },
  { lat: 24.530727, lng: 81.29911, name: 'Rewa' },
  { lat: 28.895515, lng: 76.606613, name: 'Rohtak' },
  { lat: 11.664325, lng: 78.146011, name: 'Salem' },
  { lat: 19.581099, lng: 74.205009, name: 'Sangamner' },
  { lat: 16.8508895, lng: 74.6106424, name: 'Sangli' },
  { lat: 24.953514, lng: 84.011787, name: 'Sasaram' },
  { lat: 17.6882042, lng: 74.035863, name: 'Satara' },
  { lat: 24.579716, lng: 80.832176, name: 'Satna' },
  { lat: 17.43993, lng: 78.498276, name: 'Secunderabad' },
  { lat: 13.92993, lng: 75.5681, name: 'Shivamogga' },
  { lat: 19.620296, lng: 74.654655, name: 'Shrirampur' },
  { lat: 27.63485, lng: 75.1725376, name: 'Sikar' },
  { lat: 26.732311, lng: 88.410286, name: 'Siliguri' },
  { lat: 9.453126, lng: 77.807236, name: 'Sivakasi' },
  { lat: 17.65992, lng: 75.906387, name: 'Solapur' },
  { lat: 29.903839, lng: 73.87719, name: 'Sri Ganganagar' },
  { lat: 22.7739, lng: 71.6673, name: 'Surendranagar' },
  { lat: 11.74805, lng: 75.48938, name: 'Thalassery' },
  { lat: 8.524139, lng: 76.936638, name: 'Thiruvananthapuram' },
  { lat: 9.897157, lng: 76.713409, name: 'Thodupuzha' },
  { lat: 10.530345, lng: 76.214729, name: 'Thrissur' },
  { lat: 10.7905, lng: 78.7047, name: 'Tiruchirapalli' },
  { lat: 8.741222, lng: 77.694626, name: 'Tirunelveli' },
  { lat: 13.338592, lng: 77.101208, name: 'Tumkur' },
  { lat: 24.57127, lng: 73.691544, name: 'Udaipur' },
  { lat: 23.1793, lng: 75.784912, name: 'Ujjain' },
  { lat: 19.2387176, lng: 73.1642274, name: 'Ulhasnagar' },
  { lat: 23.8077794, lng: 72.3952941, name: 'Unjha' },
  { lat: 22.310696, lng: 73.192635, name: 'Vadodara' },
  { lat: 22.5477, lng: 72.9251, name: 'Vallabh Vidhyanagar' },
  { lat: 20.6039609, lng: 72.9337587, name: 'Valsad' },
  { lat: 20.4950658, lng: 72.9017563, name: 'Vapi' },
  { lat: 25.321684, lng: 82.987289, name: 'Varanasi' },
  { lat: 19.366636, lng: 72.816101, name: 'Vasai' },
  { lat: 19.077065, lng: 72.998993, name: 'Vashi' },
  { lat: 12.934968, lng: 79.146881, name: 'Vellore' },
  { lat: 20.9114744, lng: 70.3709222, name: 'Veraval' },
  { lat: 23.524026, lng: 77.8059999, name: 'Vidisha' },
  { lat: 13.295583, lng: 77.800758, name: 'Vijayapur' },
  { lat: 16.515099, lng: 80.632095, name: 'Vijaywada' },
  { lat: 19.465622, lng: 72.806099, name: 'Virar' },
  { lat: 17.690474, lng: 83.231049, name: 'Vishakhapatnam' },
  { lat: 20.1, lng: 77.150002, name: 'Washim' },
  { lat: 20.388794, lng: 78.120407, name: 'Yavatmal' },
  { lat: 20.0431477, lng: 74.4826003, name: 'Yevla' },

  // ── Global — international presence ──
  { lat: 24.244, lng: 55.727, name: 'Al Ain, UAE' },
  { lat: 24.357, lng: 54.524, name: 'Musaffah, UAE' },
  { lat: 23.596, lng: 58.436, name: 'Al Khuwair, Oman' },
  { lat: 23.648, lng: 58.104, name: 'Mabella, Oman' },
  { lat: 26.178, lng: 50.538, name: 'Manama, Bahrain' },
  { lat: 24.438, lng: 54.412, name: 'Karama, UAE' },
  { lat: 38.499, lng: -98.297, name: 'Kansas, USA' },
  { lat: 23.619, lng: 58.545, name: 'Ruwi, Oman' },
  { lat: 25.414, lng: 51.498, name: 'Doha, Qatar' },
  { lat: 51.904, lng: 0.520, name: 'Essex, UK' },
  { lat: 51.522, lng: -0.130, name: 'London, UK' },
  { lat: 53.835, lng: -1.776, name: 'Yorkshire, UK' },
  { lat: 53.149, lng: -1.623, name: 'Derbyshire, UK' },
  { lat: 53.204, lng: -2.927, name: 'Cheshire, UK' },
  { lat: 52.637, lng: -2.686, name: 'Concord, UK' },
  { lat: 53.486, lng: -2.248, name: 'Manchester, UK' },
  { lat: 51.156, lng: -1.220, name: 'Hampshire, UK' },
  { lat: 53.502, lng: -3.000, name: 'Liverpool, UK' },
  { lat: 53.806, lng: -1.549, name: 'Leeds, UK' },
  { lat: 54.427, lng: -0.556, name: 'South Yorkshire, UK' },
  { lat: 51.358, lng: -3.062, name: 'Devon, UK' },
  { lat: 52.676, lng: -1.125, name: 'Leicester, UK' },
  { lat: 35.892, lng: 14.446, name: 'Malta' },
  { lat: 54.515, lng: -5.889, name: 'Carryduff, UK' },
  { lat: 54.601, lng: -5.921, name: 'County Down, UK' },
  { lat: 54.447, lng: -124.708, name: 'British Columbia, Canada' },
  { lat: 56.440, lng: -114.998, name: 'Alberta, Canada' },
  { lat: 51.484, lng: -86.111, name: 'Ontario, Canada' },
  { lat: 49.323, lng: -123.121, name: 'Vancouver, Canada' },
  { lat: 32.621, lng: -83.126, name: 'Georgia, USA' },
  { lat: 40.175, lng: -89.298, name: 'Illinois, USA' },
  { lat: 40.745, lng: -73.965, name: 'New York, USA' },
  { lat: 46.907, lng: -109.502, name: 'Montana, USA' },
  { lat: 34.340, lng: -111.721, name: 'Arizona, USA' },
  { lat: 36.498, lng: -119.119, name: 'California, USA' },
  { lat: 43.791, lng: -120.519, name: 'Oregon, USA' },
  { lat: 31.503, lng: -99.122, name: 'Texas, USA' },
  { lat: 27.814, lng: -81.687, name: 'Florida, USA' },
  { lat: 29.355, lng: 47.911, name: 'Kuwait' },
  { lat: -33.826, lng: 151.282, name: 'Sydney, Australia' },
  { lat: 26.191, lng: 50.556, name: 'Tubli, Bahrain' },
  { lat: 26.186, lng: 50.527, name: 'Salmabad, Bahrain' },
  { lat: 26.235, lng: 50.652, name: 'Hidd, Bahrain' },
  { lat: 26.226, lng: 50.545, name: 'Sanabis, Bahrain' },
  { lat: 23.586, lng: 58.361, name: 'Muscat, Oman' },
  { lat: 23.611, lng: 58.505, name: 'Wattayah, Oman' },
  { lat: 23.650, lng: 58.143, name: 'Seeb, Oman' },
  { lat: 22.727, lng: 58.526, name: 'Ibra, Oman' },
  { lat: 24.355, lng: 56.719, name: 'Sohar, Oman' },
  { lat: 17.0596, lng: 54.130, name: 'Salalah, Oman' },
  { lat: 24.389, lng: 54.594, name: 'Abu Dhabi, UAE' },
  { lat: 25.407, lng: 55.517, name: 'Ajman, UAE' },
  { lat: 25.338, lng: 55.415, name: 'Sharjah, UAE' },
  { lat: 25.715, lng: 55.972, name: 'Ras al Khaimah, UAE' },
  { lat: 25.547, lng: 55.548, name: 'Umm Al Quwain, UAE' },
  { lat: 25.132, lng: 56.328, name: 'Fujairah, UAE' },
  { lat: 24.968, lng: 55.042, name: 'Jebel Ali, UAE' },
  { lat: 53.165, lng: -8.020, name: 'Kilkenny, Ireland' },
  { lat: 7.949, lng: -1.130, name: 'Ghana' },
  { lat: -41.292, lng: 174.776, name: 'Wellington, New Zealand' },
  { lat: 33.781, lng: -80.226, name: 'South Carolina, USA' },
  { lat: 23.7407, lng: -103.046, name: 'Mexico' },
  { lat: 25.274, lng: 55.312, name: 'Blinds and Curtains, Dubai' },
  { lat: 37.4214007, lng: -92.0889904, name: 'Missouri, USA' },
  { lat: 53.9970856, lng: -6.4196964, name: 'Dundalk, Ireland' },
  { lat: 55.6645402, lng: -3.7973388, name: 'Lanarkshire, UK' },
  { lat: 53.3859484, lng: -2.6139778, name: 'Mersey, UK' },
  { lat: 39.4888758, lng: -77.0567245, name: 'Maryland, USA' },
  { lat: 52.486919597234504, lng: -2.858233505326408, name: 'Shropshire, UK' },
  { lat: 52.39418532860105, lng: -1.5641727309707598, name: 'Warwick, UK' },
  { lat: 52.087351972423654, lng: -0.2639038483162656, name: 'Biggleswade, UK' },
  { lat: 43.69004525120724, lng: -79.38646936055139, name: 'Toronto, Canada' },
  { lat: -36.8739172406516, lng: 174.74441701005463, name: 'Auckland, New Zealand' },
  { lat: 47.347969351015166, lng: -119.94977022822637, name: 'Washington, USA' },
  { lat: 52.2196975944287, lng: 1.064703629537829, name: 'Suffolk, UK' },
  { lat: 57.088532797852075, lng: -4.299837495672653, name: 'Scotland, UK' },
  { lat: 9.717783668008382, lng: 7.882261434116805, name: 'Nigeria' },
  { lat: 52.49036928381278, lng: -1.8907667671822002, name: 'West Midlands, UK' },
  { lat: 21.513822481755778, lng: 39.226533732127415, name: 'Jeddah, Saudi Arabia' },
  { lat: 41.456111542807434, lng: -82.7070438446286, name: 'Sandusky, USA' },
  { lat: 43.7816343587387, lng: -84.78116753390661, name: 'Michigan, USA' },
  { lat: 31.772169692551774, lng: 35.21046955246314, name: 'Jerusalem' },
];

const MAPBOX_TOKEN = 'pk.eyJ1IjoiaGFyc2hpdGE4NzQzIiwiYSI6ImNtdWh3cnRpejEwbXMyenNpNWdmaWZxbDIifQ.-kGM7E-fFZRCqH2OwJZgpw';

const MAPBOX_JS = 'https://api.mapbox.com/mapbox-gl-js/v3.1.2/mapbox-gl.js';
const MAPBOX_CSS = 'https://api.mapbox.com/mapbox-gl-js/v3.1.2/mapbox-gl.css';

function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve();
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}
function loadStyle(href, id) {
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

const PresenceMap = () => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    loadStyle(MAPBOX_CSS, 'mapbox-css');
    loadScript(MAPBOX_JS, 'mapbox-js').then(initMap);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function initMap() {
    if (!window.mapboxgl || !mapContainerRef.current) return;

    window.mapboxgl.accessToken = MAPBOX_TOKEN;

    const map = new window.mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [40, 20], // shifted so both India and the wider global spread are visible
      zoom: 1.6,
      projection: 'mercator', // flat rectangular map, not the 3D globe
      pitch: 0, // keeps the map perfectly flat (2D), no 3D tilt
      bearing: 0,
      dragRotate: false, // prevents right-click/touch drag from rotating into 3D
      pitchWithRotate: false,
      touchPitch: false,
    });
    mapRef.current = map;

    // Extra safety: disable the built-in rotation control that could tilt the map
    map.touchZoomRotate.disableRotation();

    map.on('load', () => {
      LOCATIONS.forEach((loc) => {
        const el = document.createElement('div');
        el.className = 'pmap-marker-red';
        el.innerHTML = `
          <svg width="18" height="25" viewBox="0 0 24 34" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 22 12 22s12-13 12-22c0-6.6-5.4-12-12-12z" fill="#ea4335"/>
            <circle cx="12" cy="12" r="5" fill="#ffffff"/>
          </svg>
        `;

        const popup = new window.mapboxgl.Popup({ offset: 14 }).setHTML(`<strong>${loc.name}</strong>`);

        new window.mapboxgl.Marker({ element: el, anchor: 'bottom' })
          .setLngLat([loc.lng, loc.lat])
          .setPopup(popup)
          .addTo(map);
      });
    });
  }

  return (
    <section className="Presence_PAGE">
      <div className="PresencePage_Container">
        <div className="Page-Main_Dec">
          <h1 className="Page-title_UpperCase">PRESENCE &amp; AVAILABILITY</h1>
          <p className="Page_Subtitle-Light">We are available across the world. Find our Specialist Near you…</p>
        </div>

        <div className="PresenceMap">
          <div ref={mapContainerRef} style={{ width: '100%', height: '100%' }}></div>
        </div>
      </div>
    </section>
  );
};

export default PresenceMap;